import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { parseDataAttributes } from '../helpers';
import { getRegionWithException } from './helpers';
import axios from 'axios';
import './i18n';
import { useTranslation } from 'react-i18next';
import * as moment from 'moment-timezone';

import Header from './components/header/Header';
import Main from './components/Main';
import Footer from './components/Footer';
import { getEventNameLocale } from './helpers';

const App = (props) => {
    const { i18n } = useTranslation();
    const locale = i18n.resolvedLanguage;
    const [data, setData] = useState({
        events: [],
        eventsType: {},
        categories: [],
        settings: [],
        filters: [],
    });

    const [filters, setFilters] = useState({
        type: 'all',
        regions: [],
        categories: [],
        keywords: [],
        startDate: [],
        endDate: []

    });

    const [eventsFiltered, setEventsFiltered] = useState([])

    useEffect(() => {
        axios
            .get('front/get-data', { params: { dirId: props.dirId } })
            .then((res) => {
                let data = res.data;
                setData({
                    events: data.events,
                    settings: data.settings,
                    params: { dirId: props.dirId, appUrl: props.appUrl },
                    categories: data.categories,
                });
                setEventsFiltered(data.events);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    useEffect(() => {
        applyFilters();
    }, [filters])

    const removeAccents = (str) => {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    const checkType = (event) => {
        const type = filters.type;
        const now = moment();

        if (type === 'all') {
            return true;
        } else if (type === 'upcoming') {
            return moment(event.end_date) > now;
        } else {
            return moment(event.end_date) < now;
        }
    }

    const checkRegions = (event) => {
        const regions = filters.regions;

        let eventsFilter = regions.filter((region) => {
            return getRegionWithException(event.venue).toLowerCase() === region.label.toLowerCase();
        });

        return regions.length ? eventsFilter.length : true;
    }

    const checkCategories = (event) => {
        const categories = filters.categories;

        let eventsFilter = categories.filter((category) => {
            return event.category_ids.includes(category.value)
        });

        return categories.length ? eventsFilter.length : true;
    }

    const checkKeywords = (event) => {
        let keywords = filters.keywords;
        let eventName = getEventNameLocale(event, locale);

        if (!keywords.length && eventName !== undefined) {
            return true;
        }

        keywords = removeAccents(keywords.toLowerCase());
        eventName = removeAccents(eventName.toLowerCase());

        let eventsFilter = eventName !== undefined && eventName.includes(keywords);

        return eventsFilter;
    }

    const checkDates = (event) => {
        const startDate = filters.startDate;
        const endDate = filters.endDate;
        const eventsFilter = (startDate && endDate) && moment(event.end_date).isBetween(startDate, endDate)

        return startDate.length && endDate.length ? eventsFilter : true;
    }


    const applyFilters = () => {
        let eventsFiltered = []
        if (filters.type !== 'reset_filters') {
            eventsFiltered = data.events.filter((event) => {
                return checkType(event)
                    && checkRegions(event)
                    && checkCategories(event)
                    && checkKeywords(event)
                    && checkDates(event);
            });
        } else {
            eventsFiltered = data.events;
        }
        setEventsFiltered(eventsFiltered);
    }

    function handleFilters(name, value) {
        if (value === 'reset_filters') {
            for (const [key, value] of Object.entries(filters)) {
                if (key === name) {
                    setFilters((prevState) => ({
                        ...prevState,
                        [key]: 'all',
                    }));
                } else {
                    setFilters((prevState) => ({
                        ...prevState,
                        [key]: [],
                    }));
                }
            }
        } else {
            setFilters((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    }

    return (
        <React.Fragment>
            <div className="flex flex-col w-screen h-screen">
                <Header
                    data={data}
                    filters={filters}
                    setFilters={setFilters}
                    handleFilters={handleFilters}
                    locale={locale}
                />
                <Main data={data} eventsFiltered={eventsFiltered} />
                <Footer data={data} />
            </div>
        </React.Fragment>
    );
};

const elComponentMap = document.getElementById('root');

if (elComponentMap) {
    let props = parseDataAttributes(elComponentMap);
    ReactDOM.render(<App {...props} />, elComponentMap);
}
